export default {
    app: null,
};
